import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DetailViewRoutingModule } from './detail-view-routing.module';
import { MultiViewComponent } from './multi-view/multi-view.component';

import { FlexLayoutModule } from '@angular/flex-layout';
import { ParallaxScrollModule } from 'ng2-parallaxscroll';
import { ShareModule } from 'ngx-sharebuttons';

import { MaterialModule } from '@sparro/app/material.module';
import { ImagesModule } from '@sparro/app/shared/components/images/images.module';
import { SharedModule } from '../../shared/shared.module';

import { CartDialogComponent } from './cart-dialog/cart-dialog.component';
import { DialoguePopupViewComponent } from './dialogue-popup-view/dialogue-popup-view.component';
import { DynamicPricingComponent } from './dynamic-pricing/dynamic-pricing.component';
import { EntriesComponent } from './entries/entries.component';
import { InfoComponent } from './info/info.component';
import { PartnersComponent } from './partners/partners.component';
import { PeopleComponent } from './people/people.component';
import { PrizeComponent } from './prize/prize.component';
import { ScheduleComponent } from './schedule/schedule.component';

import { ButtonsModule } from '@sparro/app/shared/components/buttons/buttons.module';
import { CardsModule } from '@sparro/app/shared/components/cards/cards.module';
import { CommentsModule } from '@sparro/app/shared/components/comments/comments.module';
import { LayoutModule } from '@sparro/app/shared/components/layout/layout.module';
import { LoaderModule } from '@sparro/app/shared/components/loader/loader.module';
import { PipesModule } from '@sparro/app/shared/pipes/pipes.module';
import { CommentsComponent } from './comments/comments.component';

import { DynamicScriptLoaderService } from '@b2b/app/shared/services/dynamic-script-loader.service';
import { CompetitionBottomsheetComponent } from './competition-bottomsheet/competition-bottomsheet.component';
import { LeaderboardComponent } from './leaderboard/leaderboard.component';
import { DialogModule } from '@sparro/app/shared/components/dialogs/dialog.module';
import { SnackbarDisplayComponent } from '@sparro/app/shared/components/dialogs/snackbar-display/snackbar-display.component';
import { TablesModule } from '@sparro/app/shared/components/tables/tables.module';


@NgModule({
  declarations: [
    MultiViewComponent,
    PartnersComponent,
    InfoComponent,
    DynamicPricingComponent,
    PeopleComponent,
    PrizeComponent,
    ScheduleComponent,
    EntriesComponent,
    DialoguePopupViewComponent,
    CartDialogComponent,
    CommentsComponent,
    LeaderboardComponent,
    CompetitionBottomsheetComponent,
  ],
  entryComponents: [SnackbarDisplayComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DetailViewRoutingModule,
    SharedModule,
    ParallaxScrollModule,
    MaterialModule,
    FlexLayoutModule,
    ShareModule,
    CardsModule,
    LoaderModule,
    ButtonsModule,
    LayoutModule,
    CommentsModule,
    PipesModule,
    ImagesModule,
    DialogModule,
    TablesModule
  ],
  providers: [DynamicScriptLoaderService]
})
export class DetailViewModule { }
